import { useState, useEffect } from "react";
// import yesIcon from "../../assets/Resources/Images/NewTickPng.png";
// import noIcon from "../../assets/Resources/Images/NewCrossPng.png";
import AllPageFooter from "./AllPageFooter";

const DoorPhotosPage = ({
  doorData,
  complianceList,
  imageProxyBaseUrl,
  //   preReq,
  PhysicalList,
  originalDoor,
  additionalPhotos,
  pageNum,
  logodata
}) => {
  const [doorImages, setDoorImages] = useState([]);
  const [totalPhotoCount, setTotalPhotoCount] = useState(0);
  // console.log("inside door photos");
  const isNullOrWhiteSpace = (str) => {
    return str == null || str.trim() === "";
  };

  //   const baseUrl = window.location.origin;
  //   const surveyUrl = `${baseUrl}/client/${preReq.clientnameParam}/viewSurvey/${preReq.propertyMasterId}/${preReq.inspectionReferenceNumber}/${doorData?.doorRefNumber}`;

  useEffect(() => {
    const loadDoorData = async () => {
      const originalImagePaths = originalDoor?.imagePaths ?? [];

      // Create a class to hold photo with comment
      let photoWithComments = [];


        // Helper function to clean photo URLs
      const clean = (src) =>
        (src || [])
          .filter((u) => typeof u === "string" && u.trim())
          .map((u) => u.trim());


      let tempPhotoCount = (originalImagePaths || []).filter(
        (p) => p && p.trim(),
      ).length;

      PhysicalList.forEach((measurement) => {
        const headPhotos = measurement?.head?.photos ?? [];
        const hingePhotos = measurement?.hinge?.photos ?? [];
        const closingPhotos = measurement?.closing?.photos ?? [];
        const thresholdPhotos = measurement?.threshold?.photos ?? [];
        const noofHingesPhotos = measurement?.noOfHinges?.photos ?? [];
        const leftheadPhotos = measurement?.leftHead?.photos ?? [];
        const rightHeadPhotos = measurement?.rightHead?.photos ?? [];
        const leftHingePhotos = measurement?.leftHinge?.photos ?? [];
        const rightHingePhotos = measurement?.rightHinge?.photos ?? [];
        const leftThresholdPhotos = measurement?.leftThreshold?.photos ?? [];
        const rightThresholdPhotos = measurement?.rightThreshold?.photos ?? [];
        //add
        tempPhotoCount += (headPhotos || []).filter(
          (p) => p && p.trim(),
        ).length;
        tempPhotoCount += (hingePhotos || []).filter(
          (p) => p && p.trim(),
        ).length;
        tempPhotoCount += (closingPhotos || []).filter(
          (p) => p && p.trim(),
        ).length;
        tempPhotoCount += (thresholdPhotos || []).filter(
          (p) => p && p.trim(),
        ).length;
        tempPhotoCount += (noofHingesPhotos || []).filter(
          (p) => p && p.trim(),
        ).length;
        tempPhotoCount += (leftheadPhotos || []).filter(
          (p) => p && p.trim(),
        ).length;
        tempPhotoCount += (rightHeadPhotos || []).filter(
          (p) => p && p.trim(),
        ).length;
        tempPhotoCount += (leftHingePhotos || []).filter(
          (p) => p && p.trim(),
        ).length;
        tempPhotoCount += (rightHingePhotos || []).filter(
          (p) => p && p.trim(),
        ).length;
        tempPhotoCount += (leftThresholdPhotos || []).filter(
          (p) => p && p.trim(),
        ).length;
        tempPhotoCount += (rightThresholdPhotos || []).filter(
          (p) => p && p.trim(),
        ).length;
      });
      const addPhotos = additionalPhotos?.imageUrls ?? [];
      tempPhotoCount += (addPhotos || []).filter((p) => p && p.trim()).length;

      complianceList.forEach((comp) => {
        const compPhotos = comp?.photos ?? [];
        tempPhotoCount += (compPhotos || []).filter(
          (p) => p && p.trim(),
        ).length;
      });

      setTotalPhotoCount(tempPhotoCount);

      

      //add door image paths
      if (originalImagePaths && originalImagePaths.length > 0) {
        clean(originalImagePaths).forEach((img) => {
          photoWithComments.push({ img, comment: "Door Photo" });
        });
      }

      // Add measurement photos with their comments
      PhysicalList.forEach((measurement) => {
        const headComment = measurement?.head?.remediation ?? "";
        if (measurement?.head?.photos && measurement?.head?.photos.length > 0) {
          clean(measurement?.head?.photos).forEach((img) => {
            photoWithComments.push({ img, comment: headComment });
          });
        }
        const hingeComment = measurement?.hinge?.remediation ?? "";
        if (
          measurement?.hinge?.photos &&
          measurement?.hinge?.photos.length > 0
        ) {
          clean(measurement?.hinge?.photos).forEach((img) => {
            photoWithComments.push({ img, comment: hingeComment });
          });
        }
        const closingComment = measurement?.closing?.remediation ?? "";
        if (
          measurement?.closing?.photos &&
          measurement?.closing?.photos.length > 0
        ) {
          clean(measurement?.closing?.photos).forEach((img) => {
            photoWithComments.push({ img, comment: closingComment });
          });
        }
        const thresholdComment = measurement?.threshold?.remediation ?? "";
        if (
          measurement?.threshold?.photos &&
          measurement?.threshold?.photos.length > 0
        ) {
          clean(measurement?.threshold?.photos).forEach((img) => {
            photoWithComments.push({ img, comment: thresholdComment });
          });
        }
        const noOfHingesComment = measurement?.noOfHinges?.remediation ?? "";
        if (
          measurement?.noOfHinges?.photos &&
          measurement?.noOfHinges?.photos.length > 0
        ) {
          clean(measurement?.noOfHinges?.photos).forEach((img) => {
            photoWithComments.push({ img, comment: noOfHingesComment });
          });
        }
        const leftHeadComment = measurement?.leftHead?.remediation ?? "";
        if (
          measurement?.leftHead?.photos &&
          measurement?.leftHead?.photos.length > 0
        ) {
          clean(measurement?.leftHead?.photos).forEach((img) => {
            photoWithComments.push({ img, comment: leftHeadComment });
          });
        }
        const rightThresholdComment =
          measurement?.rightThreshold?.remediation ?? "";
        if (
          measurement?.rightThreshold?.photos &&
          measurement?.rightThreshold?.photos.length > 0
        ) {
          clean(measurement?.rightThreshold?.photos).forEach((img) => {
            photoWithComments.push({ img, comment: rightThresholdComment });
          });
        }
        const leftHingeComment = measurement?.leftHinge?.remediation ?? "";
        if (
          measurement?.leftHinge?.photos &&
          measurement?.leftHinge?.photos.length > 0
        ) {
          clean(measurement?.leftHinge?.photos).forEach((img) => {
            photoWithComments.push({ img, comment: leftHingeComment });
          });
        }
        const rightHeadComment = measurement?.rightHead?.remediation ?? "";
        if (
          measurement?.rightHead?.photos &&
          measurement?.rightHead?.photos.length > 0
        ) {
          clean(measurement?.rightHead?.photos).forEach((img) => {
            photoWithComments.push({ img, comment: rightHeadComment });
          });
        }
        const rightHingeComment = measurement?.rightHinge?.remediation ?? "";
        if (
          measurement?.rightHinge?.photos &&
          measurement?.rightHinge?.photos.length > 0
        ) {
          clean(measurement?.rightHinge?.photos).forEach((img) => {
            photoWithComments.push({ img, comment: rightHingeComment });
          });
        }
        const leftThresholdComment =
          measurement?.leftThreshold?.remediation ?? "";
        if (
          measurement?.leftThreshold?.photos &&
          measurement?.leftThreshold?.photos.length > 0
        ) {
          clean(measurement?.leftThreshold?.photos).forEach((img) => {
            photoWithComments.push({ img, comment: leftThresholdComment });
          });
        }
        // Add custom action item photos
        const customJson = measurement?.customComplianceActionJson;
        if (!isNullOrWhiteSpace(customJson)) {
          try {
            const jsonString = customJson.trim();
            if (
              !isNullOrWhiteSpace(jsonString) &&
              jsonString !== "[]" &&
              jsonString !== "null" &&
              jsonString.startsWith("[")
            ) {
              const customAction = JSON.parse(jsonString);
              if (Array.isArray(customAction) && customAction.length > 0) {
                customAction.forEach((customActionElement) => {
                  try {
                    let customComment = "";
                    if (customActionElement?.Remediation) {
                      customComment = customActionElement?.Remediation ?? "";
                    }
                    // Extract photos from each custom action item
                    if (customActionElement?.Photos) {
                      clean(customActionElement?.Photos).forEach((phottoElement) => {
                        const img = (phottoElement ?? "").trim();
                        if (!isNullOrWhiteSpace(img)) { 
                          photoWithComments.push({
                            img,
                            comment: customComment,
                          });
                        }
                      });
                    }
                  } catch (err) {
                    //skip
                    return;
                  }
                });
              }
            }
          } catch (err) {
            //skip
          }
        }
      });
      // Add additional photos — label as "Additional photos"
      clean(addPhotos)?.map((photo) => {
        const img = photo;
        photoWithComments.push({ img, comment: "Additional Photos" });
      });
      //add copliance photos
      complianceList?.forEach((comp) => {
        const compPhotos = comp?.photos ?? [];
        const compComment = comp?.remediation ?? "";
        clean(compPhotos)?.map((photo) => {
          const img = photo;
          photoWithComments.push({ img, comment: compComment });
        });
      });

    //   const uniquePhotos = [];
    //   const seenUrls = new Set();

    //   for (const item of photoWithComments) {
    //     const url = (item?.img || "").toLowerCase(); // normalize like OrdinalIgnoreCase

    //     if (!seenUrls.has(url)) {
    //       seenUrls.add(url);
    //       uniquePhotos.push(item);
    //     }
    //   }
      setDoorImages(photoWithComments);
    };

    loadDoorData();
  }, [doorData, imageProxyBaseUrl, complianceList]);

  const resolveDoorImageurl = (str) => {
    if (isNullOrWhiteSpace(str)) return null;
    str = str.trim();
    if (str.startsWith("data:")) return str;
    if (str.length > 500 && /^[A-Za-z0-9+/=]+$/.test(str)) {
      return "data:image/jpeg;base64," + str;
    }
    return `${imageProxyBaseUrl}${str}`;
  };

  const doorLocationText = !isNullOrWhiteSpace(doorData?.doorLocation)
    ? `Door Location: Floor - ${doorData?.floorNo} - ${doorData?.doorLocation}`
    : `Door Location: Floor - ${doorData?.floorNo}`;
  const photosperPage = 6;
  const totalPhotos = doorImages?.length || 0;
  const totalPages = Math.ceil(totalPhotos / photosperPage);
  // console.log("door", doorData?.doorRefNumber, totalPages, totalPhotos )

  if (totalPhotoCount > 0 && doorImages?.length > 0) {
    return (
      <>
        {doorImages &&
          Array.from({ length: totalPages }).map(
            (_, pageIndex) => {
              const startindex = pageIndex * photosperPage;
              const endIndex = Math.min(
                startindex + photosperPage,
                totalPhotos,
              );
              const pagePhotos = doorImages?.slice(startindex, endIndex);
              const isLastPage = pageIndex === totalPages - 1;
              // console.log("page", doorData?.doorRefNumber, pageIndex, startindex, endIndex, totalPages, pagePhotos, totalPhotos )
              return (
                <div
                  key={`photos - ${pageIndex}`}
                  className={
                    isLastPage
                      ? "page sheet door-photos-wrapper"
                      : "page sheet door-photos-wrapper photosPage"
                  }
                >
                  <table className="hdr">
                    <tbody>
                      <tr>
                        <td className="hdrL">
                          <div className="hdrTitle">Flat Doors</div>
                          <p className="hdrDesc">{doorLocationText}</p>
                        </td>
                        <td className="hdrR">
                          <div className="qrBox">
                            {!isNullOrWhiteSpace(
                              doorData?.surveyQRCodeBase64,
                            ) ? (
                              <img
                                className="qrPlaceholder"
                                src={doorData?.surveyQRCodeBase64}
                                alt="QR Code"
                              />
                            ) : (
                              <div className="qrPlaceholder"></div>
                            )}
                             <div className="qrRef">{doorData?.doorRefNumber}</div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="hdrRule"></div>
                  <div className="photosSection">
                    {pageIndex === 0 && (
                      <div className="photosTitle">Photographic Records</div>
                    )}
                    <div className="photoGrid">
                      {pagePhotos &&
                        pagePhotos.map((photo, i) => {
                          const imgUrl = resolveDoorImageurl(photo?.img);
                          const photoNumber = startindex + i + 1;
                          const commt = !isNullOrWhiteSpace(photo?.comment)
                            ? photo.comment
                            : "";
                          return (
                            <div key={`photos ${pageIndex - i}`} className="photoItem">
                              <div className="photoFrame">
                                {imgUrl && (
                                  <img
                                    src={imgUrl}
                                    alt={`Photo ${photoNumber}`}
                                  />
                                )}
                                <span className="photoNumber">
                                  {photoNumber}
                                </span>
                              </div>
                              <div className="commentBox">{commt}</div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                  <AllPageFooter pageNumber={pageNum?.[pageIndex]} propLogo={logodata?.propShieldLogoBase64} />
                </div>
              );
            },
          )}
      </>
    );
  } else {
    return <></>;
  }
};

export default DoorPhotosPage;
